import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { ReactSession } from "react-client-session";
import { getSuccessToast } from "../../toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import "./ManualEntryHeader.css";
import logo from "../../assets/logo.svg";
import details from "../../assets/details.svg";
import details_active from "../../assets/details_active.svg";
import exitbox from "../../assets/exit_box.svg";
import Modal from "@mui/material/Modal";
import StockistDetails from "../scan/header/StockistDetails";

const ManualEntryHeader = () => {
  const [open, setOpen] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [partyInfo, setPartyInfo] = useState([]);
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();

  useEffect(() => {
    if (boxId) {
      axiosPrivate
        .get(`/data_entry/party-info/${ReactSession.get("box_id")}/`)
        .then((res) => {
          setPartyInfo(res.data);
        });
    }

    return () => {
      setPartyInfo([]);
    };
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const donotExitBox = () => {
    setOpen(false);
    ReactSession.remove("box_id");

    navigate("/operator");
  };

  const confirmExitBox = () => {
    const boxId = ReactSession.get("box_id");

    const data = {
      stockists_master_id: boxId,
      mark_box: "True",
    };

    axiosPrivate
      .patch("/dashboard/mark_box/", data)
      .then((res) => {
        if (res.status === 200) {
          ReactSession.remove("box_id");
          getSuccessToast("Box completed successfully", 1000);
          setTimeout(() => {
            navigate("/operator");
          }, 2000);
        }
      })
      .catch((err) => {
        console.error(err);
      });

    setOpen(false);
  };

  const displayDetails = (e) => {
    setShowDetails(true);
  };

  const hideDetaiils = (e) => {
    setShowDetails(false);
  };

  const boxId = ReactSession.get("box_id");

  return (
    <header className="manual_entry-header-container">
      <Modal open={open} onClose={handleClose}>
        <div className="delete-modal">
          <div className="delete-modal-desc">
            <img alt="bin" className="delete-modal-img" src={exitbox} />
            <p className="delete-modal-desc-para dmdp-1">
              Is this claim completed?
            </p>
          </div>
          <div className="delete-modal-btns">
            <button
              onClick={donotExitBox}
              className="delete-modal-btn dmb-1"
              id="yes"
            >
              No
            </button>
            <button
              onClick={confirmExitBox}
              className="{/*delete-modal-btn*/} box-complete-btn"
              id="no"
            >
              Yes
            </button>
          </div>
        </div>
      </Modal>
      <section className="manual_entry-header-logo">
        <Link to="/operator">
          <img
            src={logo}
            alt="logo"
            className="manual_entry-header-logo-link"
          />
        </Link>
      </section>
      {boxId ? (
        <>
          <button className="button manual_entry-header-button">
            <img
              onMouseEnter={displayDetails}
              onMouseLeave={hideDetaiils}
              src={showDetails ? details_active : details}
              alt="stockist details"
              className="manual-entry-header-container-button-images"
            />
            {/*<p>
            Stockists <br />
            Information
          </p>*/}
          </button>

          <button
            onClick={() => {
              setOpen(true);
            }}
            className="button manual_entry-header-button"
          >
            <img
              src={exitbox}
              alt="exit claim"
              className="manual-entry-header-container-button-images header-container-button-image-2"
            />
            {/*<p>Exit Box</p>*/}
          </button>
          {showDetails && <StockistDetails partyInfo={partyInfo} />}
        </>
      ) : (
        <></>
      )}
    </header>
  );
};

export default ManualEntryHeader;
